export const aceEditorMixin = {
    components: {
        editor: require('vue2-ace-editor')
    },
    methods: {
        initTextEditor() {
            require('brace/mode/text')
            require('brace/theme/chrome')
        },
        initJSONEditor() {
            require('brace/ext/language_tools')
            require('brace/mode/html')
            require('brace/mode/javascript')
            require('brace/mode/less')
            require('brace/theme/chrome')
            require('brace/snippets/javascript')
        }
    }
};
